export default {
  install(Vue) {
    Vue.prototype.$pushGTM = function(options) {
      // Send data to GTM
      var dataObject = {
        event: this.$store.state.steps ? this.$store.state.steps.calcId : null,
        category: "click",
        ...options
      };
      if (typeof window.dataLayer != "undefined") {
        window.dataLayer.push(dataObject);
      }
    };
  }
};
